// 获取订单支付信息
import { requestRaw,requestApi } from '../util/network'

// 用户支付
export const pay =
	(paySn, payType, data, key, uniapp=0) =>
		requestRaw(
			process.env.VUE_APP_SITE_URL + '/index.php?s=api/Memberpayment/' + payType + '/pay_sn/' + paySn + '/password/' + data.password + '/rcb_pay/' + data.rcb_pay + '/pd_pay/' + data.pd_pay + '/payment_code/' + data.payment_code + '/key/' + key + '/uniapp/' + uniapp + '/random_number/' + Math.random() + '/'
		)
// 用户支付new
export const payment =
	(paySn, payType, data, key, uniapp=0) =>
		requestRaw(
			process.env.VUE_APP_SITE_URL + '/index.php?s=api/Memberpayment/' + payType + '/pay_sn/' + paySn + '/password/' + data.password + '/rcb_pay/' + data.rcb_pay + '/pd_pay/' + data.pd_pay + '/payment_code/' + data.payment_code + '/key/' + key + '/uniapp/' + uniapp + '/random_number/' + Math.random() + '/'
		)
// 获取支付方式列表
export const getPaymentList =
(platform, code = '') =>
	requestApi(
		'/Memberpayment/payment_list',
		'POST',
		{
			payment_platform: platform,
			payment_code: code
		},
		'member'
	)

// 获取支付方式
export const getPayment =
(code, id) =>
	requestApi(
		'/Memberpayment/payment_info',
		'POST',
		{
			payment_code: code,
			payment_id: id
		},
		'member'
	)

// 新增會員支付資料
export const savePayment =
	(code, data) => requestApi(
		'/Memberpayment/payment_save',
		'POST',
		{
			payment_code: code,
			payment_data: data
		},
		'member'
	)

// 刪除會員支付資料
export const deletePayment =
	(payment_id) => requestApi(
		'/Memberpayment/payment_delete',
		'POST',
		{
			payment_id
		},
		'member'
	)

// 會員支付資料預設值
export const defaultPayment =
	(id) => requestApi(
		'/Memberpayment/payment_default',
		'POST',
		{
			payment_id: id
		},
		'member'
	)

export const addCreditCard = (data) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await requestRaw(
				`${process.env.VUE_APP_SITE_URL}/index.php?s=api/Memberpayment/addCreditCard`,
				'POST',
				{},
				{
					'X-DS-KEY': data.token
				}
			)
			if ((typeof res === 'object' && res.code !== 10000) || !res.startsWith('<!DOCTYPE html>')) {
				return reject(res)
			}
			resolve(res)
		} catch (err) {
			reject(err)
		}
	})
}
